import React from 'react';
import { IProps } from './types';
import UsersAndTeamsContent from './components/users-and-teams-content';

const UsersAndTeams: React.FC<IProps> = () => <UsersAndTeamsContent />;

export default UsersAndTeams;
